import { render } from "./newGamme.vue?vue&type=template&id=0e7a1b79&scoped=true"
import script from "./newGamme.vue?vue&type=script&lang=js"
export * from "./newGamme.vue?vue&type=script&lang=js"

import "./newGamme.vue?vue&type=style&index=0&id=0e7a1b79&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7a1b79"]])

export default __exports__